/* globals jQuery, AHEHC, google */
/* eslint-disable @wordpress/no-global-active-element */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';

/**
 * Internal dependencies
 */
import delegateEventListener from './theme/delegate-event';
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupTabs from './theme/tabs';
import setupAccordions from './theme/accordions';
import setupModals from './theme/modals';
import setupCarousels from './theme/carousels';
import setupDropdowns from './theme/dropdown';
import setupShareButtons from './theme/share-button';
import setupGlobe from './theme/globe';
import setupDirectoryModules from './theme/ajax-directory';

import mapStyle from './theme/map-style.json';

jQuery( $ => {
	// =========================
	// ! Flag Interaction Method
	// =========================

	function flagMouseUse() {
		document.body.classList.add( 'using-mouse' );
		document.body.classList.remove( 'using-keyboard' );
	}
	document.addEventListener( 'mousemove', flagMouseUse );
	document.addEventListener( 'touchstart', flagMouseUse );
	document.addEventListener( 'keydown', event => {
		if ( event.key === 'Tab' ) {
			document.body.classList.remove( 'using-mouse' );
			document.body.classList.add( 'using-keyboard' );
		}
	} );

	// =========================
	// ! External Link Mandate
	// =========================

	document.querySelectorAll( 'a[href^="http"]' ).forEach( anchor => {
		if ( ! anchor.target && ! anchor.href.startsWith( window.location.origin ) ) {
			anchor.setAttribute( 'target', '_blank' );
			anchor.setAttribute( 'rel', 'noreferrer noopener' );
		}
	} );

	// =========================
	// ! Basic Toggles
	// =========================

	delegateEventListener( 'click', '.js-toggle', ( event, trigger ) => {
		const target = determineTarget( trigger );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			document.body.classList.toggle( `show-${ target.id }`, isOpen );
		}
	} );

	delegateEventListener( 'click', '.js-close', ( event, trigger ) => {
		event.preventDefault();
		toggleElement( trigger.closest( '[aria-hidden="false"]' ), false );
	} );

	// close modals when navigatin away
	window.addEventListener( 'beforeunload', function() {
		document.querySelectorAll( '.js-modal' ).forEach( modal => {
			toggleElement( modal, false );
		} );
	} );

	// =========================
	// ! Peek-a-boo Nav Handling
	// =========================

	let lastScroll = 0;
	let lastDirection = null;
	let lastPastHeader = null;

	window.addEventListener( 'scroll', function() {
		const scroll = window.scrollY;
		const direction = scroll >= lastScroll ? 1 : -1;
		const pastHeader = scroll > 0;
		const hadClass = document.body.className.includes( 'animating-sticky-nav' );

		if ( direction !== lastDirection || pastHeader !== lastPastHeader ) {
			document.body.classList.toggle( 'animating-sticky-nav--in', direction < 0 && pastHeader );
			document.body.classList.toggle( 'animating-sticky-nav--out', hadClass && direction > 0 && pastHeader );
		}

		lastScroll = scroll;
		lastDirection = direction;
		lastPastHeader = pastHeader;
	} );

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.ahehc-modal' ).addClass( 'js-modal' ).appendTo( document.body );
	$( '.ahehc-modal__close' ).addClass( 'js-modal-close' );
	$( '.ahehc-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals();

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.ahehc-tab-set' ).addClass( 'js-tab-set' );
	$( '.ahehc-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.ahehc-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.ahehc-tab-set' ).each( function() {
		$( this ).find( '.ahehc-tab-header__toggle' ).first().addClass( 'auto-open' );
	} );

	setupTabs();

	// =========================
	// ! Accordion
	// =========================

	// Group adjacent accordions
	$( '.ahehc-accordion' ).each( function() {
		if ( $( this ).parent( '.ahehc-accordion-group' ).length > 0 ) {
			return;
		}

		let $group = $( this ).prev( '.ahehc-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="ahehc-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );

	// Add classes to accordion blocks automatically
	$( '.ahehc-accordion-group, .ahehc-tab-set' ).addClass( 'js-accordion-group' );
	$( '.ahehc-accordion__toggle, .ahehc-tab-header__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.ahehc-accordion__content, .ahehc-tab-panel' ).addClass( 'js-accordion-content' );

	setupAccordions( AHEHC.accordionEndpoints || [] );

	// =========================
	// ! Gallery Carousels
	// =========================

	// Prep carousels for functionality
	$( '.ahehc-carousel' ).each( function() {
		$( this ).find( '.wp-block-gallery' ).addClass( 'js-carousel-track' );
		$( this ).find( '.wp-block-image' ).addClass( 'js-carousel-slide' );
		$( this ).find( '.wp-block-image figcaption' ).addClass( 'js-slide-caption' );
	} );

	setupCarousels( { animate: true } );

	// =========================
	// ! Scroller Buttons
	// =========================

	function makeScrollerButton( type ) {
		const button = document.createElement( 'div' );
		button.className = `ahehc-scroller__button ${ type }`;
		button.setAttribute( 'aria-hidden', true );
		return button;
	}

	document.querySelectorAll( '.ahehc-scroller' ).forEach( scroller => {
		const inner = scroller.querySelector( '.ahehc-scroller__inner' );
		const navWrap = scroller.querySelector( '.ahehc-scroller__buttons' ) || scroller.querySelector( '.ahehc-scroller__header' );
		// const nav = document.createElement( 'div' );
		// nav.classList.add( 'ahehc-scroller__nav' );
		// navWrap.append( nav );
		const sampleItem = inner.querySelector( ':not(.ahehc-scroller__inner__help)' );

		const nextButton = makeScrollerButton( 'next' );
		const prevButton = makeScrollerButton( 'prev' );
		const buttons = [ nextButton, prevButton ];

		navWrap.append( nextButton, prevButton );

		prevButton.hidden = true;
		inner.addEventListener( 'scroll', () => {
			nextButton.hidden = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth;
			prevButton.hidden = inner.scrollLeft === 0;
		} );

		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				if ( button.classList.contains( 'next' ) ) {
					inner.scrollBy( {
						left: sampleItem.offsetWidth,
					} );
				} else {
					inner.scrollBy( {
						left: -1 * sampleItem.offsetWidth,
					} );
				}
			} );
		} );
	} );

	document.addEventListener( 'keyup', event => {
		if ( event.key === 'Tab' ) {
			const scroller = document.activeElement?.closest( '.ahehc-scroller__inner' );
			if ( scroller ) {
				document.activeElement.scrollIntoView( {
					block: 'nearest',
					inline: 'nearest',
				} );
			}
		}
	} );

	// =========================
	// ! Dropdown
	// =========================

	setupDropdowns();

	// =========================
	// ! Excerpt Handling
	// =========================

	$( '.ahehc-excerpt' ).each( function() {
		$( this ).toggleClass( 'is-clamped', this.scrollHeight > this.offsetHeight );
	} );

	$( document ).on( 'click', '.js-expand', function() {
		const expanded = $( this ).closest( '.is-expandable' ).toggleClass( 'is-expanded' ).hasClass( 'is-expanded' );

		// Swap the text with the cached label
		const label = $( this ).data( 'label' ) || ( expanded ? 'Show less' : 'Show more' );
		$( this ).data( 'label', $( this ).text() );
		$( this ).text( label );
	} );

	// =========================
	// ! Wizard Nav Menu
	// =========================

	document.querySelectorAll( '.ahehc-wizard-nav' ).forEach( ( wizard, menuIndex ) => {
		wizard.tabIndex = -1;

		const wizardPanelToggles = new WeakMap();
		const wizardBackButtons = new WeakMap();

		let panelCount = 0;
		const allPanels = [];
		function menu2panel( menu, backLabel ) {
			panelCount++;

			const panel = document.createElement( 'div' );
			panel.id = menu.id || `menu-${ menuIndex + 1 }-panel-${ panelCount }`;
			panel.tabIndex = -1;
			panel.classList.add( 'ahehc-wizard-nav__panel' );
			panel.setAttribute( 'role', 'navigation' );
			panel.setAttribute( 'aria-hidden', true );

			const classes = [ ...menu.classList ];
			panel.classList.add( ...classes.filter( className => className !== 'sub-menu' ) );

			menu.classList.add( 'ahehc-wizard-nav__menu' );
			menu.removeAttribute( 'id' );
			panel.append( menu );
			wizard.append( panel );
			allPanels.push( panel );

			// Loop through items for those with submenus
			[ ...menu.children ].forEach( item => {
				if ( ! item.classList.contains( 'menu-item-has-children' ) ) {
					return;
				}

				// First of each should be direct decendents
				let toggle = item.querySelector( '.menu-item-label, .menu-item-link' );
				const label = toggle.textContent;
				const submenu = item.querySelector( '.sub-menu' );

				// Setup panel for the submenu, have it link back to here
				const subPanel = menu2panel( submenu, `Back to ${ label }` ); // textContent since it's currently hidden

				// Add heading
				const heading = document.createElement( 'h2' );
				heading.classList.add( 'ahehc-wizard-nav__heading' );
				heading.innerText = label;

				// Recreate as button
				if ( toggle.classList.contains( 'menu-item-link' ) ) {
					const link = toggle;
					link.textContent = link.title || `${ label } Overview`;
					link.removeAttribute( 'title' );

					if ( item.classList.contains( 'header-button' ) ) {
						const buttonWrap = document.createElement( 'span' );
						buttonWrap.classList.add( 'wp-block-button', 'has-color-inverse' );
						link.classList.remove( 'menu-item-link' );
						link.classList.add( 'wp-block-button__link' );
						buttonWrap.append( link );
						heading.append( buttonWrap );
					} else {
						const linkWrap = document.createElement( 'li' );
						linkWrap.classList.add( 'menu-item' );
						linkWrap.append( link );
						submenu.prepend( linkWrap );
					}

					toggle = document.createElement( 'button' );
					toggle.classList.add( 'menu-item-label' );
					toggle.textContent = label;

					item.prepend( toggle );
				} else if ( toggle.tagName !== 'button' ) {
					toggle.remove();

					toggle = document.createElement( 'button' );
					toggle.classList.add( 'menu-item-label' );
					toggle.textContent = label;

					item.prepend( toggle );
				}

				toggle.setAttribute( 'aria-controls', subPanel.id );
				subPanel.prepend( heading );

				// Create back button
				const backButton = document.createElement( 'button' );
				backButton.classList.add( 'menu-item-label', 'ahehc-wizard-nav__back', 'js-submenu-close' );
				backButton.innerText = backLabel;

				subPanel.prepend( backButton );

				// Log the toggle the panel goes to
				wizardPanelToggles.set( subPanel, toggle );
				// Log the panel the back button points to
				wizardBackButtons.set( backButton, panel );
			} );

			return panel;
		}

		const mainPanel = menu2panel( wizard.querySelector( '.menu' ), 'Back to Main Menu' );
		mainPanel.setAttribute( 'aria-hidden', false );

		wizard.addEventListener( 'click', event => {
			const toggle = event.target;

			let newPanel;
			// See if it's a submenu toggle
			if ( toggle.hasAttribute( 'aria-controls' ) ) {
				newPanel = determineTarget( toggle );
			} else
			// Or back button
				if ( toggle.classList.contains( 'js-submenu-close' ) ) {
					newPanel = wizardBackButtons.get( toggle );
				}

			if ( ! newPanel ) {
				return;
			}

			// Get the current panel to close
			const currentPanel = allPanels.find( panel => panel.getAttribute( 'aria-hidden' ) === 'false' );

			// Skip if somehow the same panel
			if ( currentPanel === newPanel ) {
				return;
			}

			// Hide current panel, mark toggle if present
			currentPanel.setAttribute( 'aria-hidden', true );
			const currentToggle = wizardPanelToggles.get( currentPanel );
			if ( currentToggle ) {
				currentToggle.setAttribute( 'aria-expanded', false );
			}

			// Show new panel, mark toggle if present
			newPanel.setAttribute( 'aria-hidden', false );
			const newToggle = wizardPanelToggles.get( newPanel );
			if ( newToggle ) {
				newToggle.setAttribute( 'aria-expanded', true );
			}

			( currentToggle || newPanel.querySelector( 'a, button' ) ).focus();
		} );
	} );

	// =========================
	// ! Google Map Stuff
	// =========================

	$( '.js-map-canvas' ).each( function() {
		const config = $( this ).data( 'config' );
		const { center, position, zoom, options = {} } = config;

		const map = new google.maps.Map( this, {
			center,
			zoom,
			gestureHandling: 'cooperative',
			fullscreenControl: false,
			mapTypeControl: false,
			streetViewControl: false,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM,
			},
			// eslint-disable-next-line
			styles: mapStyle,
		} );

		if ( position ) {
			let markerSize = 200;
			if ( document.innerWidth > 1000 ) {
				markerSize = 340;
			}

			const marker = new google.maps.Marker( {
				position,
				icon: {
					url: AHEHC.assetsUrl + '/img/marker-large.svg',
					size: new google.maps.Size( 340, 340 ),
					scaledSize: new google.maps.Size( markerSize, markerSize ),
					anchor: new google.maps.Point( markerSize * .5, markerSize * .647 ),
				},
			} );

			marker.setMap( map );
		}
	} );

	// =========================
	// ! Globe Stuff
	// =========================

	$( '.js-globe-module' ).each( function() {
		const globeCanvas = this.querySelector( '.js-globe-canvas' );
		const { chart, pointSeries } = setupGlobe( globeCanvas );

		const filters = this.querySelectorAll( '.js-globe-filter' );
		const items = this.querySelectorAll( '.js-globe-item' );

		function filterItems() {
			items.forEach( item => {
				const dataItem = pointSeries.getDataItemById( item.id );

				let hidden = false;
				filters.forEach( filter => {
					if ( filter.value ) {
						const filterClass = `${ filter.name }-${ filter.value }`;
						if ( ! item.classList.contains( filterClass ) ) {
							hidden = true;
						}
					}
				} );

				item.hidden = hidden;

				if ( dataItem ) {
					if ( hidden ) {
						pointSeries.hideDataItem( dataItem, 300 );
					} else {
						pointSeries.showDataItem( dataItem, 300 );
					}
				}
			} );
		}

		items.forEach( item => {
			item.addEventListener( 'mouseenter', () => {
				const dataItem = pointSeries.getDataItemById( item.id );
				if ( dataItem ) {
					const sprite = dataItem.bullets[ 0 ].get( 'sprite' );
					sprite.animate( {
						key: 'scale',
						to: 2,
						duration: 200,
					} );
				}
			} );

			item.addEventListener( 'mouseleave', () => {
				const dataItem = pointSeries.getDataItemById( item.id );
				if ( dataItem ) {
					const sprite = dataItem.bullets[ 0 ].get( 'sprite' );
					sprite.animate( {
						key: 'scale',
						to: 1,
						duration: 200,
					} );
				}
			} );
		} );

		this.addEventListener( 'change', filterItems );
	} );

	// =========================
	// ! Hidden Target Handling
	// =========================

	function handleHiddenTarget( event ) {
		// Get the target element
		const target = document.getElementById( window.location.hash.substring( 1 ) );
		if ( ! target ) {
			return;
		}

		// See if it's within a hidden container
		const container = target.closest( '[id][aria-hidden="true"]' );
		if ( ! container ) {
			return;
		}

		// Find the control for the container
		const control = document.querySelector( `[aria-controls=${ container.id }]` );
		if ( ! control ) {
			return;
		}

		// Prevent automatic scolling
		if ( event ) {
			event.preventDefault();
		}

		// Open the container and focus
		control.click();
		target.scrollIntoView();
	}

	window.addEventListener( 'hashchange', handleHiddenTarget );
	handleHiddenTarget();

	// =========================
	// ! Bookmark/Share Links
	// =========================

	setupShareButtons();

	$( 'a.js-clipboard' ).on( 'click', e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a.js-clipboard', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	const clipboardTooltipTimeouts = new WeakMap();
	hrefClipboard.on( 'success', e => {
		clearTimeout( clipboardTooltipTimeouts.get( e.trigger ) );
		$( e.trigger ).addClass( 'js-copied' ).attr( 'aria-label', 'Link copied!' );
		const timeout = setTimeout( () => $( e.trigger ).removeClass( 'js-copied' ), 5000 );
		clipboardTooltipTimeouts.set( e.trigger, timeout );
	} );

	// =========================
	// ! Directory Module
	// =========================

	setupDirectoryModules();
} );
